import type { AxiosResponse } from 'axios';

import type { DepositPaymentMethodsResponse } from '@/interfaces/user';

import request from '../request';

/**
 *
 * Add and retrieve Paysafe user credit cards
 */
export const getDepositPaymentMethods = async (): Promise<
  AxiosResponse<DepositPaymentMethodsResponse>
> => {
  const response = await request({
    method: 'GET',
    requiresLatLong: true,
    underdogAPIVersion: 'financial_orchestration/api/v1',
    url: '/deposits/payment_methods',
  });

  return response;
};
